import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";
import { getMatchReportById, clearState } from "./listMatchReportSlice";
import MatchReportDisplay from "../../common/components/match-report/MatchReportDisplay";

const OrgViewListMatchReportContainer = () => {
    const { id } = useParams();
    const matchReportState = useSelector(state => state.listMatchReport);
    const dispatch = useDispatch();

    const [downloading, setDownloading] = useState(false);
    const reportSimpleMatchInfoRef = useRef(null);
    const reportRow2Ref = useRef(null);
    const reportRow3Ref = useRef(null);
    const reportGeography = useRef(null);
    const reportRow5Ref = useRef(null);
    const reportRow6Ref = useRef(null);
    const reportRow7Ref = useRef(null);
    const reportRow8Ref = useRef(null);
    const reportRow9Ref = useRef(null);

    useEffect(() => {
        if (id) {
            dispatch(getMatchReportById(id));
        }
    }, [id, dispatch]);

    const handleDownloadPDF = async () => {
        setDownloading(true);

        await new Promise((resolve) => setTimeout(resolve, 1000));
        await document.fonts?.ready?.catch(() => {});

        const margin = 10;
        const pageWidthMm = 450;
        const usableWidth = pageWidthMm - margin * 2;

        const sectionRefs = [
            reportSimpleMatchInfoRef,
            reportRow2Ref,
            reportRow3Ref,
            reportGeography,
            reportRow5Ref,
            reportRow6Ref,
            reportRow7Ref,
            reportRow8Ref,
            reportRow9Ref,
        ];

        const rendered = [];

        for (const ref of sectionRefs) {
            const el = ref.current;
            if (!el) continue;

            const style = window.getComputedStyle(el);
            if (style.display === "none" || el.offsetHeight === 0 || el.offsetWidth === 0)
                continue;

            const prevOverflow = el.style.overflow;
            el.style.overflow = "visible";

            const canvas = await html2canvas(el, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
                logging: false,
                backgroundColor: "#ffffff",
                scrollY: -window.scrollY,
                scrollX: -window.scrollX,
                windowWidth: document.documentElement.scrollWidth,
                windowHeight: document.documentElement.scrollHeight,
            });

            el.style.overflow = prevOverflow;

            if (!canvas || canvas.width === 0 || canvas.height === 0) continue;

            const imgData = canvas.toDataURL("image/jpeg", 0.6);
            const aspectRatio = canvas.height / canvas.width;
            const targetHeightMm = usableWidth * aspectRatio;

            rendered.push({ imgData, targetHeightMm });
        }

        const spacing = 5;
        const totalHeightMm =
            margin + rendered.reduce((sum, r) => sum + r.targetHeightMm + spacing, 0);

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [pageWidthMm, totalHeightMm],
        });

        let currentY = margin;
        for (const r of rendered) {
            const h = Math.max(1, r.targetHeightMm - 1);
            pdf.addImage(r.imgData, "JPEG", margin, currentY, usableWidth, h);
            currentY += r.targetHeightMm + spacing;
        }

        pdf.save(`Match_Report_${id}.pdf`);
        setDownloading(false);
    };

    const matchReportError = matchReportState.alertMessage;

    return (
        <div>
            {matchReportState.loading && <SpinnerOverlay />}
            <MatchReportDisplay
                matchReport={matchReportState.listMatchReport}
                matchReportError={matchReportError}
                onClearMatchReportError={() => dispatch(clearState())}
                reportSimpleMatchInfoRef={reportSimpleMatchInfoRef}
                reportRow2Ref={reportRow2Ref}
                reportRow3Ref={reportRow3Ref}
                reportGeography={reportGeography}
                reportRow5Ref={reportRow5Ref}
                reportRow6Ref={reportRow6Ref}
                reportRow7Ref={reportRow7Ref}
                reportRow8Ref={reportRow8Ref}
                reportRow9Ref={reportRow9Ref}
                handleDownloadPDF={handleDownloadPDF}
                downloading={downloading}
            />
        </div>
    );
};

export default OrgViewListMatchReportContainer;
